.root {

  min-width: 0;

  width: 100%;

  display: flex;

  flex-direction: column;

  /* Grow only for workspace pages; default pages size to content and scroll via mainInner */

  flex: 1 1 auto;

  min-height: 0;

}


